// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3z7v9","emails":"CreateEditClinics_emails__2uFgW","emailTagLabel":"CreateEditClinics_emailTagLabel__19t4t"};